import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(30, 136, 229, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(30, 136, 229, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(30, 136, 229, 0);
  }
`;

export const HighlightOverlay = styled.div`
  /* AJUSTE: position:fixed faz o highlight acompanhar o scroll.
     Para mudar para absolute, some scrollY/scrollX no cálculo de posição. */
  position: fixed;
  z-index: 9999;
  /* AJUSTE: pointer-events:none garante que o highlight não bloqueia cliques.
     Para bloquear cliques nesta área também, mude para 'auto'. */
  pointer-events: none;
  border-radius: 4px;
  animation: ${pulse} 1.5s infinite;
  border: 2px solid #1e88e5;
  background-color: rgba(30, 136, 229, 0.1);
`;
